import { render, staticRenderFns } from "./TemplateFieldModal.vue?vue&type=template&id=b37b48f6&scoped=true"
import script from "./TemplateFieldModal.vue?vue&type=script&lang=js"
export * from "./TemplateFieldModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateFieldModal.vue?vue&type=style&index=0&id=b37b48f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37b48f6",
  null
  
)

export default component.exports